export const GetAllSoftwareTagsCourseList = `
query SoftwareTargsCourseList{
    SoftwareTags{
      tagid
      name
      tagtype{
        tagtypeid
        name
      }
    }
}
`;
